var _ChatClipServiceInit_clips;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
class ChatClipServiceInit {
    constructor() {
        _ChatClipServiceInit_clips.set(this, writable([]));
    }
    get clips() {
        return __classPrivateFieldGet(this, _ChatClipServiceInit_clips, "f");
    }
    updateClips(clips) {
        __classPrivateFieldGet(this, _ChatClipServiceInit_clips, "f").set(clips);
    }
}
_ChatClipServiceInit_clips = new WeakMap();
export const ChatClipService = new ChatClipServiceInit();
